module.exports = __webpack_public_path__ + "img/hero-bg.06bd8773.jpg";